<template>
  <StandaloneHTMLPreview
    v-if="resource.htmlPreview?.body"
    :no-shadow="noShadow"
    :resource="resource"
  />
  <!-- Fallback to Component-based block preview (legacy) -->
  <StandaloneBlockPreview
    v-else
    :block-modules="blockModules"
    :no-shadow="noShadow"
    :preview-footer="previewFooter"
    :preview-heading="previewHeading"
    :resource="resource"
    :sections="sections"
  />
</template>

<script>
import StandaloneBlockPreview from './StandaloneBlockPreview.vue'
import StandaloneHTMLPreview from './StandaloneHTMLPreview.vue'

export default {
  name: 'StandaloneBuilderPreview',
  components: {
    StandaloneBlockPreview,
    StandaloneHTMLPreview,
  },
  props: {
    /**
     * Block Modules
     * @private
     */
    blockModules: { type: Array, default: () => [] },

    /**
     * Hide box shadow
     * @public
     */
    noShadow: { type: Boolean, default: false },

    /**
     * Preview Footer
     * @private
     */
    previewFooter: { type: Object, default: undefined },

    /**
     * Preview Header
     * @private
     */
    previewHeading: { type: Object, default: undefined },

    /**
     * Resource Data
     * @public
     */
    resource: { type: Object, required: true },

    /**
     * Section Data
     * @public
     */
    sections: { type: Array, required: true },
  },
}
</script>
